import React, { useEffect, useState } from 'react';
import { apiGet } from '../../lib/api';

export default function AdminLeads() {
  const [list, setList] = useState([]);
  useEffect(() => { apiGet('/admin/leads').then(r => setList(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="space-y-4" data-testid="admin-leads">
      <h1 className="font-heading font-extrabold text-3xl text-rozops-navy">Leads</h1>
      <div className="bg-white rounded-2xl border border-gray-100 shadow-soft overflow-x-auto">
        <table className="w-full">
          <thead className="bg-rozops-bg border-b border-gray-100">
            <tr className="text-left text-xs uppercase tracking-wider text-rozops-text-muted font-bold">
              <th className="py-3 px-6">Name</th><th className="py-3 px-6">Business</th><th className="py-3 px-6">Contact</th><th className="py-3 px-6">Type</th><th className="py-3 px-6">Source</th><th className="py-3 px-6">Date</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-rozops-text-muted">No leads yet.</td></tr>}
            {list.map(l => (
              <tr key={l.id} className="border-b border-gray-50">
                <td className="py-4 px-6 font-semibold">{l.full_name}</td>
                <td className="py-4 px-6 text-sm">{l.business_name || '—'}</td>
                <td className="py-4 px-6 text-sm text-rozops-text-muted">{l.email}<br/>{l.phone}</td>
                <td className="py-4 px-6 text-sm">{l.merchant_type || '—'}</td>
                <td className="py-4 px-6 text-xs uppercase font-bold text-rozops-blue">{l.source}</td>
                <td className="py-4 px-6 text-xs text-rozops-text-muted">{(l.created_at || '').slice(0, 10)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
